import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"
import CustomRewardTransactionFragment from "../fragment/CustomRewardTransaction"

const query = gql`
  query CustomRewardsTransactions($filters: ListCustomRewardsTransactionsFilter, $pagination: PaginationInput) {
    customRewardsTransactions(filters: $filters, pagination: $pagination) {
      results {
        ...CustomRewardTransaction
      }
      cursor
      hasMore
    }
  }

  ${CustomRewardTransactionFragment}
`
export const getCustomRewardsTransactionsQueryKey = getQueryNames(query)[0]
export default query
